import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    cardStyle,
    cardHeaderStyle,
    cardTitleStyle,
    cardContentStyle,
} from './styles/SsoConfirm.css';
import Button from '../common/Button';
import {formatExternalUrl} from '../../functions/FormatUrl';

export class SsoConfirm extends Component {
    handleClick = e => {
        e.preventDefault();
        window.location.href = formatExternalUrl(this.props.query.r);
    };

    render() {
        let title = "Lone Wolf Account Link Confirmation";
        let body = <div>
                    {`Your Lone Wolf Account has been successfully linked to ${this.props.tokenData.appName}.`}
                    <br/>
                    {`From now on, please log in to ${this.props.tokenData.appName} using this email.`}
                </div>;
        if(this.props.createConfirm){
            title = "Lone Wolf Account Create Confirmation";
            body = <div>
                    {`Your Lone Wolf Account has been successfully created. You will now be able to log in to ${this.props.tokenData.appName} using your Lone Wolf Account email and password.`}
                </div>;
        }

        return (
            <div className="container content">
                <br/>
                <div className="card" style={cardStyle}>
                    <div className="card-body">
                        <div style={cardHeaderStyle}>
                            <div className="card-title" style={cardTitleStyle}>
                                {title}
                            </div>
                            {body}
                        </div>
                        <div style={cardContentStyle}>
                            <Button
                                classNames={["btn-lg"]}
                                action={this.handleClick}
                                text="GOT IT!"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    query: state.initial.queryInfo,
    tokenData: state.initial.tokenData,
    createConfirm: state.signupReducer.createConfirm ? state.signupReducer.createConfirm : false
});

export default connect(mapStateToProps)(SsoConfirm);
